import { render, staticRenderFns } from "./MarketFXView.vue?vue&type=template&id=87b24962&scoped=true"
import script from "./MarketFXView.vue?vue&type=script&lang=js"
export * from "./MarketFXView.vue?vue&type=script&lang=js"
import style0 from "./MarketFXView.vue?vue&type=style&index=0&id=87b24962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b24962",
  null
  
)

export default component.exports